import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { SubscriptionType } from './subscription-type.model';
import { SubscriptionTypePopupService } from './subscription-type-popup.service';
import { SubscriptionTypeService } from './subscription-type.service';

@Component({
    selector: 'jhi-subscription-type-delete-dialog',
    templateUrl: './subscription-type-delete-dialog.component.html'
})
export class SubscriptionTypeDeleteDialogComponent {

    subscriptionType: SubscriptionType;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private subscriptionTypeService: SubscriptionTypeService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['subscriptionType', 'recurrence']);
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete(id: number) {
        this.subscriptionTypeService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'subscriptionTypeListModification',
                content: 'Deleted an subscriptionType'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-subscription-type-delete-popup',
    template: ''
})
export class SubscriptionTypeDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private subscriptionTypePopupService: SubscriptionTypePopupService
    ) { }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.subscriptionTypePopupService
                .open(SubscriptionTypeDeleteDialogComponent as Component, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/subscription-type/subscription-type-delete-dialog.component.ts